import { ExclamationSolid, Text, TextProps } from '@bonusly/design-system';

export const WarningMessage = ({ children, ...rest }: TextProps) => {
	return (
		<Text display="flex" alignItems="center" color="warning.text" fontSize={50} lineHeight={5} {...rest}>
			<ExclamationSolid size="md" color="warning.icon" pr={1} />
			{children}
		</Text>
	);
};
